import PropTypes from 'prop-types';
import { Component } from 'react';

class InputBookmarkedUsers extends Component {
  state = { isChecked: this.props.defaultChecked };

  handleChange = () => {
    const { onChange } = this.props;

    this.setState((prevState) => ({ isChecked: !prevState.isChecked }));
    onChange();
  };

  render() {
    const { isChecked } = this.state;

    return (
      <div className="push-half--bottom">
        <label className="weight--normal">
          <input
            type="checkbox"
            name="query[bookmarked_users]"
            className="push-half--right v-middle"
            value={isChecked}
            checked={isChecked}
            onChange={this.handleChange}
          />
          {AlumniConnect.currentNetwork?.network_config?.user_bookmarks_label}
        </label>
      </div>
    );
  }
}

InputBookmarkedUsers.propTypes = {
  onChange: PropTypes.func.isRequired,
  defaultChecked: PropTypes.bool,
};

InputBookmarkedUsers.defaultProps = {
  defaultChecked: false,
};

export default InputBookmarkedUsers;
